import React from "react"
import Layout from "../components/layout"
import { motion } from "framer-motion"
import { Link } from "gatsby"

import NavBar from "../components/NavBar"

import FooterSection from "../sections/footer-section"

import { theme } from "../theme/theme"

const FAQPage = () => (
  <Layout>
    <motion.div style={{ height: "100%" }}>
      <NavBar
        style={{
          position: "absolute",
          width: "100%",
          top: 0,
          backgroundColor: theme.colors.white0,
          zIndex: 1,
        }}
      />
      <motion.div
        id={"shipping-container"}
        style={{
          height: "auto",
          width: "100vw",
          backgroundColor: theme.colors.white0,
          display: "flex",
          justifyContent: "center",
          paddingLeft: "10%",
          paddingRight: "10%",
        }}
      >
        <motion.div style={{ width: "100%", paddingTop: 125 }}>
          <motion.h1 style={{ paddingBottom: 20 }}>
            Delivery & Shipping
          </motion.h1>
          <motion.h4 className={"faq-question"}>
            Can I track the status of my order?
          </motion.h4>
          <motion.p>
            Currently all shipping is handled through the label you made your
            purchase through. If you have any questions, you can reach out to
            the label directly, or{" "}
            <Link to={"/contact"}>send us a message</Link>.
          </motion.p>
          <motion.h4 className={"faq-question"}>
            How long will it take before I receive my package?
          </motion.h4>
          <motion.p>
            Please note that Brand New Labels is just an intermediate who
            connect you to our independent labels. All the products are managed
            and shipped by our labels. We ask all our labels to send every order
            within 2 or 3 working days. You can assume that you can hold and
            love your item within 5 working days.
          </motion.p>
          <motion.p>
            In case of complaints, questions or uncertainties, Brand New Labels
            is here to help. Please do not hesitate to contact us.
          </motion.p>
          <motion.h4 className={"faq-question"}>
            Do I have to pay for the shipping cost?
          </motion.h4>
          <motion.p>
            Certain labels' products have an added shipping fee, which is added
            automatically upon checkout. There are no additional costs unless
            noted on the product!
          </motion.p>
          <motion.h4 className={"faq-question"}>
            What should I do if my order hasn't been delivered yet?
          </motion.h4>
          <motion.p>
            Cancel your plans, sit down and wait. If you wait longer dan 5
            working days, please send an e-mail included your order number to
            <a href="mailto:info@brandnewlabels.com">info@brandnewlabels.com</a>
            .
          </motion.p>
          <motion.p>
            We are sorry if you have to wait long for order. We hope it’s all
            worth it! Please note that Brand New Labels is just an intermediate
            who connect you to our independent labels. All the products are
            managed and shipped by our labels. We ask all our labels to send
            every order within 2 or 3 working days. You can assume that you can
            hold and love your item within 5 working days.
          </motion.p>
        </motion.div>
      </motion.div>
      <motion.div
        id={"returns-container"}
        style={{
          height: "auto",
          width: "100vw",
          backgroundColor: theme.colors.white0,
          display: "flex",
          justifyContent: "center",
          paddingLeft: "10%",
          paddingRight: "10%",
          paddingTop: 125,
        }}
      >
        <motion.div style={{ width: "100%" }}>
          <motion.h1>Returns & Refunds </motion.h1>
          <motion.h4 className={"faq-question"}>
            Can I return or exchange an item?
          </motion.h4>
          <motion.p>
            We want you to be happy! If for any reason you are unsatisfied with
            your item, we will happily accept it back within 30 days of your
            order purchase date. Please note, all returned items must be in
            their original condition (unworn, unwashed and unused) and all tags
            must be attached with packaging in its original condition.
          </motion.p>

          <motion.p>
            Return postage costs are the responsibility of the customer unless
            the item is faulty. Please note, once your order has been placed
            unfortunately we cannot make any changes or cancellations. We’re
            sorry for any inconvenience
          </motion.p>
          <motion.h4 className={"faq-question"}>
            How can I return an item?
          </motion.h4>
          <motion.p>
            Please note that Brand New Labels is just an intermediate who
            connect you to our independent labels. All the products are managed
            and shipped by our labels. For returning your items, you can send an
            e-mail to info@brandnewlabels. Within 2 or 3 days, we will send you
            the return address of the relevant seller. They wil take it from
            there. In case of complaints, questions or uncertainties, Brand New
            Labels is here to help. Please do not hesitate to contact us.
          </motion.p>
          <motion.p>
            Send us an email to{" "}
            <a href="mailto:info@brandnewlabels.com">info@brandnewlabels.com</a>{" "}
            with the following information:
          </motion.p>
          <motion.ul>
            <motion.li>Order #</motion.li>
            <motion.li>Product Name</motion.li>
            <motion.li>Date of Purchase</motion.li>
            <motion.li>Reason for return</motion.li>
          </motion.ul>
          <motion.h4 className="faq-question">
            When can I expect my refund?
          </motion.h4>
          <motion.p>
            Once your return is received and inspected, we will send you an
            email to notify you that we have received your returned item. We
            will also notify you of the approval or rejection of your refund. If
            you are approved, your refund will be processed, and a credit will
            automatically be applied to your credit card or original method of
            payment, within 5 days.
          </motion.p>
        </motion.div>
      </motion.div>
      <motion.div
        id={"faq-container"}
        style={{
          height: "auto",
          width: "100vw",
          backgroundColor: theme.colors.white0,
          display: "flex",
          justifyContent: "center",
          paddingLeft: "10%",
          paddingRight: "10%",
        }}
      >
        <motion.div
          style={{ width: "100%", paddingTop: 125, paddingBottom: 125 }}
        >
          <motion.h1>FAQ</motion.h1>
          <motion.h4 className={"faq-question"}>
            Who should I contact if I have a question?
          </motion.h4>
          <motion.p>
            You can send us a message directly, from our{" "}
            <Link to="/contact">contact page</Link>, or by sending us an email
            to{" "}
            <a href="mailto:info@brandnewlabels.com">info@brandnewlabels.com</a>
            .
          </motion.p>
          <motion.h4 className={"faq-question"}>
            Can I cancel or change my order after I've placed it?
          </motion.h4>
          <motion.p>
            Brand New Labels is an intermediate who connect you to the newest
            and swaggest upcoming labels. When the order is placed, the order
            will be immediately put through to the corresponding label. Because
            all orders are picked up directly by the seller, it is not possible
            to change or cancel your order afterwards.
          </motion.p>
          <motion.h4 className={"faq-question"}>
            Do you provide any warranty?
          </motion.h4>
          <motion.p>
            It is a long established fact that a reader will be distracted by
            the readable content of a page when looking at its layout. The point
            of using Lorem Ipsum is that it has a more-or-less normal
            distribution of letters, as opposed to using ‘Content here, content
            here’, making it look like readable English. Many desktop publishing
            packages and web page editors now use Lorem Ipsum as their default
            model text, and a search for ‘lorem ipsum’ will uncover many web
            sites still in their infancy. Various versions have evolved over the
            years, sometimes by accident, sometimes on purpose (injected humour
            and the like).
          </motion.p>
          <motion.h4 className={"faq-question"}>
            I've received a faulty or damaged item, what should I do?
          </motion.h4>
          <motion.p>
            If you received an item classified as faulty or damaged, please
            inform us within 7 days after receiving your order at{" "}
            <a href="mailto:info@brandnewlabels.com">info@brandnewlabels.com</a>
            . Please accompany this request with your order number and (if
            needed) images to clarify the reason of this request.
          </motion.p>
          <motion.h4 className={"faq-question"}>
            I'm missing an item from my order, what do I do?
          </motion.h4>
          <motion.p>
            If an item is missing, please send an e-mail including your order
            nummer to{" "}
            <a href="mailto:info@brandnewlabels.com">info@brandnewlabels.com</a>
            . Please note that the products are sent separately from each other,
            if you have ordered by different labels. All the products are
            managed and shipped by the independent labels. Brand New Labels is
            just an intermediate who connects you to the newest and swaggest
            upcoming labels.
          </motion.p>
        </motion.div>
      </motion.div>

      <FooterSection />
    </motion.div>
  </Layout>
)

export default FAQPage
